import { Box, Skeleton } from '@mui/material';

export const ContactChartSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '30%',
          marginTop: 0.5,
          marginBottom: 1,
        }}
      >
        <Skeleton variant='text' animation='wave' height='29px' />
        <Skeleton variant='text' animation='wave' height='17px' />
      </Box>
      <Box
        sx={{
          mt: { xs: 0, sm: 2 },
          width: '70%',
          ml: { xs: 0, sm: 2 },
        }}
      >
        <Skeleton variant='rectangular' animation='wave' sx={{ borderRadius: 1, height: '10px' }} />
      </Box>
    </Box>
  );
};
